"use client";

import React from "react";

import { createSVGIcon } from "./util";

export const ChatBubbleSquare = createSVGIcon(
  <path
    d="M7.71408 21.4289L0.856934 23.1431L2.57122 18.0003V2.57171C2.57122 2.11705 2.75183 1.68102 3.07332 1.35952C3.39481 1.03803 3.83085 0.857422 4.28551 0.857422H21.4284C21.883 0.857422 22.3191 1.03803 22.6405 1.35952C22.962 1.68102 23.1426 2.11705 23.1426 2.57171V19.7146C23.1426 20.1692 22.962 20.6053 22.6405 20.9267C22.3191 21.2482 21.883 21.4289 21.4284 21.4289H7.71408Z"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
  />,
  "ChatBubbleSquare",
  { viewBox: "0 0 24 24", fill: "none" } // This icon is decorative, keep titleAccess empty so it doesn't clutter the screenreader experience
);
